export default function FooterHandshake() {
  return <svg
    className="footer-handshake-art"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 220"
    fill="none"
    stroke="currentColor"
    strokeWidth="6.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    data-art-style="white-line-handshake"
  >
    <g transform="translate(14 -14) scale(.72)">
      <g data-handshake-detail="rays">
        <path d="m146 68 27 30m15-55 11 38m42-38-12 39m57-14-31 31" />
      </g>
      <g data-handshake-detail="sleeves">
        <path d="m30 216 25-117 73 25-49 102Z" />
        <path d="m296 119 72-16 5 123h-45Z" />
        <circle cx="58" cy="206" r="6" fill="currentColor" stroke="none" />
        <circle cx="350" cy="209" r="6" fill="currentColor" stroke="none" />
      </g>
      <path d="M122 136h63m112-5-47-9c-24-5-44 0-59 15-13 13-22 30-29 46 20 15 40 2 55-24l66 65c9 8 10 17 2 24-7 7-15 5-23-2l-44-45" />
      <path d="M289.3 232.22 324 221M83 219l20 19" />
      <path d="m262 246 13 13c7 7 7 15 0 22-7 6-15 4-21-2l-57-59" />
      <path d="m247 272c9 8 11 16 4 23-6 7-15 6-22-1l-55-57" />
      <path d="m219 284c7 7 8 15 1 22-6 5-13 4-20-3l-9-9" />
      <g data-handshake-detail="fingers">
        <path d="m101 241 4-5c6-7 14-8 20-3 6 4 6 12 1 19l-5 6c-5 7-13 8-19 3-6-5-6-13-1-20Z" />
        <path d="m124 251 8-10c5-7 14-8 20-3 6 5 6 13 1 20l-10 14c-5 7-14 8-20 3-6-5-6-13-1-20Z" />
        <path d="m145 267 9-13c5-7 14-8 20-3 6 5 6 13 1 20l-11 15c-5 7-13 8-19 3-6-5-6-13-1-20Z" />
        <path d="m166 282 7-9c5-7 13-8 19-3 6 5 6 13 1 20l-7 10c-5 7-13 8-19 3-6-5-6-13-1-21Z" />
      </g>
    </g>
  </svg>
}
